import { ApolloLink, Observable } from "@apollo/client";
import { getFieldNodes } from "../graphql/documentUtils/entrypoint";
import { createMissingSchemaLink } from "./createMissingSchemaLink";
/**
 * Creates a link that detects which schema a mutation belongs to and
 * executes the mutation against that schema's link.
 * @param schemas The Sail GraphQL config.
 * @returns Apollo link that will handle mutations for any schema.
 */ export default function createMutationSchemaLink(schemaIdToApolloLink, topLevelFieldsToSchemaId) {
    return new ApolloLink(function mutationSchemaLink(operation, forward) {
        var _operationContext_graphQlOperation, _topLevelFieldsToSchemaId_mutationField_name_value;
        const operationContext = operation.getContext();
        if (((_operationContext_graphQlOperation = operationContext.graphQlOperation) === null || _operationContext_graphQlOperation === void 0 ? void 0 : _operationContext_graphQlOperation.type) !== 'MUTATION') {
            // When used as a terminating link, forward is undefined
            if (forward) {
                return forward(operation);
            }
            throw new Error('Mutation link used as a terminating link was given a non mutation operation. This is a noop.');
        }
        const mutationFields = getFieldNodes(operation.query);
        if (mutationFields.length !== 1) {
            throw new Error('Mutations only support a single field at a time so operations remain atomic');
        }
        const mutationField = mutationFields[0];
        const schemaId = (_topLevelFieldsToSchemaId_mutationField_name_value = topLevelFieldsToSchemaId[mutationField.name.value]) === null || _topLevelFieldsToSchemaId_mutationField_name_value === void 0 ? void 0 : _topLevelFieldsToSchemaId_mutationField_name_value.schemaId;
        const schemaLink = schemaIdToApolloLink[schemaId] || createMissingSchemaLink();
        return new Observable((observer)=>{
            const subscription = ApolloLink.execute(schemaLink, {
                query: operation.query,
                variables: operation.variables,
                context: operationContext
            }).subscribe({
                next: (result)=>{
                    observer.next(result);
                },
                error: (error)=>{
                    observer.error(error);
                }
            });
            return ()=>subscription.unsubscribe();
        });
    });
}

//# sourceMappingURL=createMutationSchemaLink.js.map